import React from "react";
import {useEffect} from "react";
import {css} from "@panda/css";

import {gtmApplicationPutAside} from "../../../tracking/google_tag_manager/gtm_application_put_aside";
import {useLeadData} from "../../hooks/use_lead_data";
import {useLeadRequiredParams} from "../../hooks/use_lead_required_params";
import {getSentLeadFormValuesFromStorage} from "../../utils/lead/sent_lead_form_values";
import {ApplicationGoodbyeContent, IApplicationGoodbyeContentProps} from "./ApplicationGoodbyeContent";

interface IProps extends IApplicationGoodbyeContentProps {}

export function ApplicationGoodbyeContentModal(props: IProps) {
    const {vendorId, offerId} = useLeadRequiredParams();
    const data = useLeadData({vendorId, offerId: offerId || undefined});

    useEffect(() => {
        const sentLeadFormValues = getSentLeadFormValuesFromStorage();

        const areFormValuesAvailable =
            sentLeadFormValues && Boolean(sentLeadFormValues.name) && Boolean(sentLeadFormValues.email) && Boolean(sentLeadFormValues.phone);

        if (data && areFormValuesAvailable) {
            gtmApplicationPutAside(data.vendor?.detail, data.offer?.detail);
        }
    }, []);

    return <ApplicationGoodbyeContent closeModal={props.closeModal} className={wrapperStyle} />;
}

const wrapperStyle = css({
    md: {
        width: "896px",
        height: "644px"
    }
});
import React from "react";
import {useEffect} from "react";
import {css} from "@panda/css";

import {gtmApplicationPutAside} from "../../../tracking/google_tag_manager/gtm_application_put_aside";
import {useLeadData} from "../../hooks/use_lead_data";
import {useLeadRequiredParams} from "../../hooks/use_lead_required_params";
import {getSentLeadFormValuesFromStorage} from "../../utils/lead/sent_lead_form_values";
import {ApplicationGoodbyeContent, IApplicationGoodbyeContentProps} from "./ApplicationGoodbyeContent";

interface IProps extends IApplicationGoodbyeContentProps {}

export function ApplicationGoodbyeContentModal(props: IProps) {
    const {vendorId, offerId} = useLeadRequiredParams();
    const data = useLeadData({vendorId, offerId: offerId || undefined});

    useEffect(() => {
        const sentLeadFormValues = getSentLeadFormValuesFromStorage();

        const areFormValuesAvailable =
            sentLeadFormValues && Boolean(sentLeadFormValues.name) && Boolean(sentLeadFormValues.email) && Boolean(sentLeadFormValues.phone);

        if (data && areFormValuesAvailable) {
            gtmApplicationPutAside(data.vendor?.detail, data.offer?.detail);
        }
    }, []);

    return <ApplicationGoodbyeContent closeModal={props.closeModal} className={wrapperStyle} />;
}

const wrapperStyle = css({
    md: {
        width: "896px",
        height: "644px"
    }
});
